import { motion } from "framer-motion";
import { graphql, useStaticQuery } from "gatsby";
import React from "react";
import { designAni2 } from "./animation";
import { DevShow } from "./DevShow";

function DevList() {
  const data = useStaticQuery(graphql`
    query {
      allContentfulNewProjects {
        nodes {
          id
          title
          banner {
            gatsbyImageData(layout: FULL_WIDTH)
          }
          body {
            body
          }
          livesite
          repo
        }
      }
    }
  `);

  const {
    allContentfulNewProjects: { nodes },
  } = data;

  return (
    <>
      <div className="devList--wrapper">
        <motion.div className="top--dev--section">
          <motion.h1
            variants={designAni2}
            initial="initial"
            animate="animate"
            exit={{
              y: 100,
              opacity: 0,
              transition: { duration: 0.6, delay: 0.3, ease: "easeIn" },
            }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            Dev projects
          </motion.h1>
          <motion.p
            variants={designAni2}
            initial="initial"
            animate="animate"
            exit={{
              y: 100,
              opacity: 0,
              transition: { duration: 0.6, delay: 0.2, ease: "easeIn" },
            }}
            transition={{ duration: 0.9, ease: "easeOut", delay: 0.2 }}
          >
            My freelance and personal dev projects
          </motion.p>
        </motion.div>
        <DevShow nodes={nodes} />
       
      </div>
    </>
  );
}

export { DevList };
